/* eslint-disable react/no-array-index-key */
import { Row, Col, Container } from 'react-bootstrap';
import { AnchorLink } from '../../../Components/button';
import { SimpleCard } from '../../../Components/Card';
import {
  HeadingDescSmall,
  SectionInnerHeading
} from '../../../Components/Headings';
import { RightArrowWithBorder } from '../../../Components/icons';
import { SectionHeading } from '../../../Components/SectionHeading';
import image from '../../../assets/images/png/faetured-doctor.png';
import './featuredDoctor.css';

const featuredDocs = [
  {
    docImg: image,
    docName: 'Dr. Madeeha Asad',
    docExp: 'Experience: 20+ Years'
  },
  {
    docImg: image,
    docName: 'Dr. Madeeha Asad',
    docExp: 'Experience: 20+ Years'
  },
  {
    docImg: image,
    docName: 'Dr. Madeeha Asad',
    docExp: 'Experience: 20+ Years'
  },
  {
    docImg: image,
    docName: 'Dr. Madeeha Asad',
    docExp: 'Experience: 20+ Years'
  }
];

function FeaturedDoctor() {
  return (
    <section className="featuredDoctor">
      <Container>
        <SectionHeading
          heading="Featured Doctors"
          icon={<RightArrowWithBorder />}
          link={<AnchorLink to="/doctorListing" text="view all" />}
        />
        <div className="featuredDoctorRow">
          <Row>
            {featuredDocs.map((featuredDoc, index) => {
              const { docImg, docName, docExp } = featuredDoc;
              return (
                <Col key={index} md={3}>
                  <SimpleCard>
                    <div className="imgBox">
                      <img src={docImg} alt="docImg" />
                    </div>
                    <div className="cardBody">
                      <SectionInnerHeading text={docName} />
                      <HeadingDescSmall text={docExp} />
                    </div>
                  </SimpleCard>
                </Col>
              );
            })}
          </Row>
        </div>
      </Container>
    </section>
  );
}

export default FeaturedDoctor;
